import { Badge } from "@capawesome/capacitor-badge";

export default function setApplicationIconBadgeNumber(count) {
  Badge.set({ count });
}
